import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './InvoiceEditMenu.module.scss';

const link = cx(styles.link, 'd-flex', 'align-items-center', 'px-3', 'py-2');

const InvoiceEditMenu = ({
  onDownload,
  onDelete,
  onPaid,
  onRetryPayment,
  showPaymentButton,
  hasCardPayment,
  hasFailedPayment,
  isDownloading,
  isDeleting,
  isMarkingPaid,
  isRetrying,
  selectedId,
  currentItemId,
}) => {
  const isCurrentItem = selectedId === currentItemId;
  const isLoading = isDownloading || (isCurrentItem && (isDeleting || isMarkingPaid)) || isRetrying;

  return (
    <ul
      className={cx(styles.wrapper, 'radius-4', 'bg-white', 'py-2', 'px-0')}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <li
        className={cx(styles.listItem, (isDownloading || isLoading) && styles.disabled)}
        onClick={!isDownloading && !isLoading ? onDownload : undefined}
      >
        <div className={link}>
          <i className={cx(isDownloading ? 'icon-loading icon-spin' : 'icon-download', 'me-2')} />
          Download
        </div>
      </li>
      <li
        className={cx(styles.listItem, ((isCurrentItem && isMarkingPaid) || isLoading) && styles.disabled)}
        onClick={!isLoading && !(isCurrentItem && isMarkingPaid) ? onPaid : undefined}
      >
        <div className={link}>
          <i className={cx(isCurrentItem && isMarkingPaid ? 'icon-loading icon-spin' : 'icon-check-mark', 'me-2')} />
          Mark as paid
        </div>
      </li>
      {showPaymentButton && (
        <li
          className={cx(styles.listItem, (!hasCardPayment || isRetrying || isLoading) && styles.disabled)}
          onClick={hasCardPayment && !isRetrying && !isLoading ? onRetryPayment : undefined}
          title={!hasCardPayment ? 'No payment method on file' : undefined}
        >
          <div className={link}>
            <i className={cx(isRetrying ? 'icon-loading icon-spin' : 'icon-creditcard-face', 'me-2')} />
            {hasFailedPayment ? 'Retry Payment' : 'Pay'}
          </div>
        </li>
      )}
      <li
        className={cx(styles.listItem, ((isCurrentItem && isDeleting) || isLoading) && styles.disabled)}
        onClick={!isLoading && !(isCurrentItem && isDeleting) ? onDelete : undefined}
      >
        <div className={link}>
          <i className={cx(isCurrentItem && isDeleting ? 'icon-loading icon-spin' : 'icon-trash', 'me-2')} />
          Delete
        </div>
      </li>
    </ul>
  );
};

InvoiceEditMenu.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onPaid: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onRetryPayment: PropTypes.func,
  showPaymentButton: PropTypes.bool,
  hasCardPayment: PropTypes.bool,
  hasFailedPayment: PropTypes.bool,
  isDownloading: PropTypes.bool,
  isDeleting: PropTypes.bool,
  isMarkingPaid: PropTypes.bool,
  isRetrying: PropTypes.bool,
  selectedId: PropTypes.string,
  currentItemId: PropTypes.string,
};

InvoiceEditMenu.defaultProps = {
  onRetryPayment: () => {},
  showPaymentButton: false,
  hasCardPayment: false,
  hasFailedPayment: false,
  isDownloading: false,
  isDeleting: false,
  isMarkingPaid: false,
  isRetrying: false,
  selectedId: null,
  currentItemId: null,
};

export default InvoiceEditMenu;
